import { getEndpoint, getHeaders } from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_USER_CONNECTIONS = 'REQUEST_FETCH_STATS_USER_CONNECTIONS';
export const SUCCESS_FETCH_STATS_USER_CONNECTIONS = 'SUCCESS_FETCH_STATS_USER_CONNECTIONS';
export const FAIL_FETCH_STATS_USER_CONNECTIONS = 'FAIL_FETCH_STATS_USER_CONNECTIONS';

export const fetchStatsUserConnections = (onSuccess, onFail, onRequest) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_USER_CONNECTIONS });
        if (onRequest) onRequest();

        fetch(getEndpoint('fetchStatsUserConnections'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({ type: FAIL_FETCH_STATS_USER_CONNECTIONS });
                else dispatch({ type: SUCCESS_FETCH_STATS_USER_CONNECTIONS, data });

                if (onSuccess) onSuccess(data);
            })
            .catch((error, type = FAIL_FETCH_STATS_USER_CONNECTIONS) => {
                if (onFail) onFail(type, error);
                dispatch({ type, error });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/userConnections.js